// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"6fe7b3ec9b40eea6a819","243":"b9e49f0c4364bb5ead67","682":"42decabe499554162257","688":"625128d5425bfa33527c","738":"83ada334f3636c7fe8a6","765":"85e2cb3a12e4732aa483","852":"bac65f9dfc1431c85322"}[chunkId] + ".bundle.js";
};